import React, { useState, useEffect } from 'react';
import { X, ExternalLink } from 'lucide-react';
import axios from 'axios';

const API = '/api';

const AnnouncementBanner = () => {
  const [banner, setBanner] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const wasDismissed = sessionStorage.getItem('announcement_banner_dismissed');
    if (wasDismissed) {
      setDismissed(true);
      return;
    }
    const fetchBanner = async () => {
      try {
        const res = await axios.get(`${API}/announcement-banner`);
        if (res.data?.enabled) {
          setBanner(res.data);
        }
      } catch {
        // Silent fail
      }
    };
    fetchBanner();
  }, []);

  if (dismissed || !banner) return null;

  const handleDismiss = () => {
    setDismissed(true);
    sessionStorage.setItem('announcement_banner_dismissed', 'true');
  };

  return (
    <div className="bg-[#1a5fb4] text-white relative z-50" data-testid="announcement-banner">
      <div className="max-w-7xl mx-auto px-4 py-2.5 flex items-center justify-center gap-3 flex-wrap text-center">
        <div className="flex flex-col sm:flex-row items-center gap-1 sm:gap-3">
          {banner.headline && (
            <span className="font-bold text-sm sm:text-base" data-testid="banner-headline">
              {banner.headline}
            </span>
          )}
          {banner.subtext && (
            <span className="text-xs sm:text-sm text-blue-100" data-testid="banner-subtext">
              {banner.subtext}
            </span>
          )}
        </div>
        {banner.cta_text && banner.cta_url && (
          <a
            href={banner.cta_url}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => {
              axios.post(`${API}/banner-click`, {
                element: 'announcement_banner',
                headline: banner.headline,
                subtext: banner.subtext,
                cta_text: banner.cta_text,
                cta_url: banner.cta_url
              }).catch(() => {});
            }}
            className="inline-flex items-center gap-1.5 bg-white text-[#1a5fb4] px-3 py-1 rounded-full text-xs sm:text-sm font-semibold hover:bg-blue-50 transition-colors whitespace-nowrap"
            data-testid="banner-cta"
          >
            {banner.cta_text}
            <ExternalLink className="h-3 w-3" />
          </a>
        )}
        <button
          onClick={handleDismiss}
          className="absolute right-2 top-1/2 -translate-y-1/2 p-1 rounded-full hover:bg-white/20 transition-colors"
          aria-label="Dismiss banner"
          data-testid="banner-dismiss"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
};

export default AnnouncementBanner;
